import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Preview } from './Preview'
import { Youtube } from '../pages/Youtube'
import YouTube from 'react-youtube'
import { isMobile } from 'react-device-detect'
import { GuideToUse } from './GuideToUse'
import { Modal } from './layout/Modal'

export const FAQ = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const [isPreview, setPreview] = useState<boolean>(true)
  const [isRefundModal, setRefundModal] = useState<boolean>(false)
  return (
    <div className="mb-[80px] flex w-[343px] flex-col items-center gap-[16px] md:mb-10 md:w-[816px] md:items-start">
      {pathname === '/' && (
        <div className="flex w-full flex-col gap-[16px]">
          <p className="text-[34px] font-bold md:text-[40px]">
            <span className="text-main">많이 묻는 질문 + 빠른 해결법</span> FAQ
          </p>
        </div>
      )}
      <div className="flex w-full flex-col gap-2 text-[#2E343D]">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <p className="text-[24px] font-bold">
            패스트컷 상품 영상 샘플 + {isMobile && <br />}서비스 소개 영상
          </p>
          <a
            className="text-[18px] text-[#5E6068]"
            href="https://angelleague.notion.site/AI-kr-15bba20e97f3809b8d33d7b08aaacd3f?pvs=4"
            target="_blank"
            rel="noreferrer"
          >{`더보기 >`}</a>
        </div>
        {isMobile ? (
          <>
            <div className="flex flex-col gap-2">
              <YouTube
                videoId={'UUu4FD1Fti0'}
                opts={{ width: '343', height: '180' }}
              />

              <YouTube
                videoId={'eBx_lXdxxHw'}
                opts={{ width: '343', height: '180' }}
              />
              <div>
                <YouTube
                  videoId={'K88BCTLTNIU'}
                  opts={{ width: '343', height: '180' }}
                />
              </div>
              <YouTube
                videoId={'kjOXDIvw9rs'}
                opts={{ width: '343', height: '180' }}
              />
            </div>
          </>
        ) : (
          <>
            <div className="flex gap-2">
              <YouTube
                videoId={'UUu4FD1Fti0'}
                opts={{ width: '198', height: '112' }}
              />
              <YouTube
                videoId={'eBx_lXdxxHw'}
                opts={{ width: '198', height: '112' }}
              />
              <div>
                <YouTube
                  videoId={'K88BCTLTNIU'}
                  opts={{ width: '198', height: '112' }}
                />
              </div>
              <YouTube
                videoId={'kjOXDIvw9rs'}
                opts={{ width: '198', height: '112' }}
              />
            </div>
          </>
        )}
      </div>
      <div className="flex w-full flex-col gap-[32px] rounded-[40px] bg-[#F6F8FB] p-[32px] text-[#2E343D]">
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">패스트컷은 어떤 서비스인가요?</p>

          <p className="text-[18px] text-[#5E6068]">
            패스트컷은 AI로 웹페이지 내용을 분석하여 컨텐츠 영상 혹은 상품
            영상을 만들어 주는 서비스입니다.
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            <span className="">패스트컷 상품 영상</span> 기능을 사용하려면 뭘
            준비해야 하나요?
          </p>
          <ul className="ml-5 list-disc text-[18px] text-[#5E6068]">
            <li>
              본인의 쿠팡 파트너스나 알리 익스프레스 어필리에이트 계정이 있어야
              합니다.{' '}
            </li>
            <li>영상을 등록할 본인의 유튜브 채널도 준비하셔야 하구요. </li>
            <li>
              상품 정보가 잘 등록될 수 있도록 유튜브 채널의 설정이 적합하게
              되어있어야 합니다.{' '}
            </li>
            <li>
              상품 정보 수집을 위해 사용하시는 브라우저에 패스트컷 확장
              프로그램이 설치되어 있어야 합니다. 기타 필요한 사항들은 아래
              항목들에서 꼼꼼히 확인해주세요!
            </li>
          </ul>
        </div>
        <div className="flex flex-col">
          <p className="mt-2 text-[24px] font-bold">
            패스트컷 확장 프로그램이 뭔가요?
          </p>
          <p className="text-[18px] text-[#5E6068]">
            패스트컷 확장 프로그램은 크롬, 엣지, 웨일 브라우저에 설치하여 쿠팡 /
            알리익스프레스에서 상품 데이터를 수집하는 솔루션을 말해요.
          </p>
          <ul className="ml-5 list-disc text-[18px] text-[#5E6068]">
            <li>상품명 자동 입력</li>
            <li>상품 이미지 미리보기 및 선택 </li>
            <li>최대 240개까지 수집한 상품 목록 관리</li>
          </ul>
          <p className="text-[18px] text-[#5E6068]">
            등의 기능으로 압도적으로 편리한 영상 생성을 경험 해보세요!
          </p>
        </div>
        <div className="flex flex-col">
          <p className="mt-2 text-[24px] font-bold">
            패스트컷 확장 프로그램을 꼭 사용해야 하나요?
          </p>
          <p className="text-[18px] text-[#5E6068]">
            네! 꼭 사용해주시기를 부탁드립니다.
            <br /> 확장 프로그램을 사용하지 않고, 상품 페이지 링크를
            복사/붙여넣기 해서 영상 생성을 요청하실 수 있습니다. 다만, 확장
            프로그램을 사용하셔야 영상에 사용될 이미지 등의 상품 정보를 미리
            보실 수 있기 때문에 영상의 퀄리티를 직접 관리하시는 면에서 편의성이
            현저히 높아집니다.
          </p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            쿠팡 파트너스 어떻게 만드나요?
          </p>
          <p className="text-[18px]">
            패스트컷이 준비한 가장 쉬운 가입 방법 안내서를 참고하세요!{' '}
            <span className="font-bold text-href underline">
              <a
                href="https://blog.fastseller.shop/coupangpartnersguide/"
                target="_blank"
                rel="noreferrer"
              >
                쿠팡 파트너스 가입 가이드
              </a>
            </span>
          </p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            알리익스프레스 어필리에이트 어떻게 만드나요?
          </p>
          <p className="text-[18px]">
            패스트컷이 준비한 가장 쉬운 가입 방법 안내서를 참고하세요!{' '}
            <span className="font-bold text-href underline">
              <a
                href="https://blog.fastseller.shop/aliexpressaffiliatteguide/"
                target="_blank"
                rel="noreferrer"
              >
                {' '}
                알리 어필리에이트 가입 가이드{' '}
              </a>
            </span>
          </p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            패스트컷 유튜브 자동 업로드 기능이 무엇인가요?
          </p>
          <p className="text-[18px]">
            생성된 영상을 사용자의 유튜브 채널에 자동으로 업로드(영상 등록)
            해드리는 혁신적인 기능입니다. 최초 1회 유튜브 채널 관리자 권한과
            고급기능 세팅만 해 놓으면, 사용자가 따로 신경쓰지 않아도 시간
            분배까지 해서 차곡차곡 영상이 예약 등록 됩니다. 패스트컷의
            프로/프리미엄 플랜에서 제공하는 기능입니다.
          </p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            자동 업로드 되게 하려면 어떻게 하나요?
          </p>
          <p className="text-[18px]">
            첫째, 내가 운영하는 유튜브 채널의 편집자 권한을 패스트컷에게
            부여해야 합니다.{' '}
            <span className="font-bold text-href underline">
              <a
                href="https://blog.fastseller.shop/fastcutai_youtube_upload_guide/"
                target="_blank"
                rel="noreferrer"
              >
                {' '}
                채널 권한부여 가이드{' '}
              </a>
            </span>
          </p>
          <p className="text-[18px]">
            둘째, 유튜브 고급기능 신청을 해서 승인을 받아야 합니다.{' '}
            <span className="font-bold text-href underline">
              <a
                href="https://blog.fastseller.shop/youtubeadvancedverification/"
                target="_blank"
                rel="noreferrer"
              >
                {' '}
                유튜브 고급기능 신청 가이드{' '}
              </a>
            </span>
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            유튜브 채널 권한 부여가 무엇인가요? 어떻게 하나요?
          </p>
          <p className="text-[18px]">
            내가 운영하는 유튜브 채널에 패스트컷이 영상을 등록할 수 있도록
            편집자 자격을 주는 행위입니다. 나의 유튜브 스튜디오에서 아주 간단히
            10초만에 할 수 있는 설정이에요! 가이드를 보고 미리 설정 해두시면
            좋습니다.{' '}
            <span className="font-bold text-href underline">
              <a
                href="https://blog.fastseller.shop/fastcutai_youtube_upload_guide/"
                target="_blank"
                rel="noreferrer"
              >
                {' '}
                채널 권한부여 가이드
              </a>
            </span>
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            유튜브 고급기능 신청은 왜 필요한가요? 어떻게 하나요?
          </p>
          <p className="text-[18px]">
            유튜브에 영상을 등록할 때 꼭 필요한 기능들이 있습니다. 대표 썸네일을
            고르고, 설명 내용에 상품 링크를 넣고, 댓글을 고정하는 것 등등
            인데요, 고급기능 승인을 받아야 이 기능들을 사용할 수 있어요.
            패스트컷 사용을 위한 것이 아니더라도 내 유튜브 채널을 운영하는 데
            필요한 승인이니 미리 받아두시면 좋습니다. 고급기능 승인을 위해서는
            신분증 인증이 필요하니 준비 해주시고 패스트컷이 만든 가이드를 보고
            시작하세요! <br />
            <span className="font-bold text-href underline">
              <a
                href="https://blog.fastseller.shop/youtubeadvancedverification/"
                target="_blank"
                rel="noreferrer"
              >
                {' '}
                유튜브 고급기능 신청 가이드
              </a>
            </span>
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            내가 만든 영상의 자동 업로드(영상 등록)는 언제 되나요?
          </p>
          <p className="text-[18px]">
            <ul className="ml-5 list-disc">
              <li>자동 업로드 설정이 완료된 상태여야 가능합니다. </li>
              <li>
                영상 생성 완료 후 48시간 이내에 업로드 예약이 시작됩니다.{' '}
              </li>

              <li>
                프로,프리미엄 플랜은 1일 최대 3개까지 오전 10시, 오후 2시, 오후
                6시에 업로드 예약 됩니다
              </li>
              <li>
                생성과 업로드 일정 등은 서비스 현황에 따라 별도의 공지 없이
                변동될 수 있습니다.{' '}
              </li>
            </ul>
          </p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            영상 파일 다운로드, 생성과 등록 현황 등은 어디서 확인하나요?
          </p>
          <p className="text-[18px]">
            패스트컷 사이트에 로그인 한 상태에서, 오른쪽 상단에 있는 [MY 메뉴]를
            선택하시면 그 하위에{' '}
            <span
              className="cursor-pointer text-href"
              onClick={() => {
                navigate('/my-videos')
              }}
            >
              [사용현황]
            </span>{' '}
            메뉴가 있어요. 사용현황 페이지에서 내가 생성 요청한 영상들의 현재
            상태와 파일 다운로드 등을 하실 수 있습니다.
          </p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            영상 썸네일은 변경해도 되나요?
          </p>
          <p className="text-[18px]">네. 변경 하셔도 됩니다!</p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            쿠팡 파트너스의 고지 문구는 자동으로 들어가나요?
          </p>
          <p className="text-[18px]">네. 설명 내용에 자동으로 들어갑니다!</p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            상품명과 제목은 왜 이모지, 특수문자를 제한하고 25자 이내로 써야
            하나요?
          </p>
          <p className="text-[18px]">
            상품명과 제목은 영상의 대표 썸네일, 인트로 화면, 상단 정보 영역,
            설명 내용에 사용됩니다. 그래서 길이가 너무 길거나 특수기호 등이
            들어가면 유튜브 스튜디오 자체에서 제한하는 경우가 있고, 영상
            생성시에 폰트 오류를 일으킬 수 있어 제한하고 있습니다.
          </p>
        </div>

        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            패스트컷으로 <span className="">컨텐츠 영상</span> 어떻게 만드나요?
          </p>
          <div className="ml-2 flex flex-col text-[18px] text-[#5E6068]">
            <ul className="ml-4 list-decimal">
              <li>
                {' '}
                텍스트와 이미지 컨텐츠가 있는 페이지를 준비해주세요! 예를 들어
                본인이 운영하고 있는 네이버 블로그 페이지나 네이버 뉴스 페이지
                등이 있습니다.
              </li>
              <li>
                {' '}
                해당 페이지의 링크를 복사해서 패스트컷의{` `}
                <button
                  className="font-bold text-href underline"
                  onClick={() => {
                    navigate('/short-video-editor')
                  }}
                >
                  컨텐츠 영상 만들기 페이지
                </button>
                의 안내에 따라 붙여넣으세요!
              </li>
              <li>
                {' '}
                유튜브 제목과 영상에 들어갈 효과들을 입력한 후 생성 요청하시면
                됩니다.
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            <span className="">컨텐츠 영상</span> 만들 때 이미지 추가해도
            되나요?
          </p>
          <p className="text-[18px] text-[#5E6068]">
            네 가능합니다! 하나의 컨텐츠당 5개 파일(합계 용량 20MB미만)까지 추가
            가능하며, 저작권에 유의하세요!
          </p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            자막은 오타 없나요? 수정 가능한가요?
          </p>
          <p className="text-[18px] text-[#5E6068]">
            패스트컷의 자막은 자막을 일일이 수정하는 노고를 덜어드리는 것을
            목표로 개발한 기능으로, 타 서비스들에 비해 오타 및 오류가 현저히
            적습니다. 그래서 수정 기능은 따로 준비하지 않았습니다.
          </p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="text-[24px] font-bold">
            패스트컷이 제공하는 배경음악은 저작권 문제가 없나요?
          </p>
          <p className="text-[18px]">네. 문제 없습니다!</p>
        </div>

        <div className="flex gap-1">
          <button
            className="text-center text-[14px] text-[#8F929B] underline md:text-left"
            onClick={() => {
              setRefundModal(true)
            }}
          >
            서비스 안내
          </button>
          <span className="t text-[14px] text-[#8F929B]">|</span>
          <button
            className="text-center text-[14px] text-[#8F929B] underline md:text-left"
            onClick={() => {
              setRefundModal(true)
            }}
          >
            환불 안내
          </button>
        </div>
      </div>

      <GuideToUse />

      {isRefundModal && (
        <Modal isModal={isRefundModal}>
          <div className="z-50 w-[343px] rounded-t-[20px] bg-white p-[20px]">
            <div className="flex flex-col items-center justify-center gap-[16px]">
              <p className="text-[18px] font-bold">
                <span className="text-error">💌</span> 이메일 문의
              </p>
              <div className="flex flex-col items-center gap-[8px]">
                <p className="text-[#62D4D2 font-bold]">
                  아래 이메일로 문의해주세요!
                </p>
                <p className="text-[20px] font-bold">coo@capbox.kr</p>
              </div>
              <div className="flex flex-col items-center text-[14px]">
                <p className="font-bold">패스트컷에 가입하신</p>
                <p>
                  <span className="font-bold text-error">이메일</span>과{' '}
                  <span className="font-bold text-error">플랜 정보</span>를
                </p>
                <p>
                  문의 메일 내용에{' '}
                  <span className="font-bold text-[#FF7D7D]">
                    꼭 포함해주셔야
                  </span>
                </p>
                <p className="font-bold text-[#FF7D7D]">
                  안내가 진행 가능합니다!
                </p>
              </div>
            </div>
          </div>
          <div className="flex h-[60px] w-[343px] items-center justify-center rounded-b-[20px] bg-main font-bold">
            <button
              className="h-full w-full text-white"
              onClick={() => {
                setRefundModal(false)
              }}
            >
              확인
            </button>
          </div>
        </Modal>
      )}
    </div>
  )
}
